// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "a71d08e98ba7011ca0765d2331be32c063ffe81a/static/css/" + chunkId + "." + "8ea9c403" + ".chunk.css";
};